module.exports = __webpack_public_path__ + "static/media/loading.661beb61.svg";